<div class="invoice-list-wrapper">
  <!-- Buyer view -->
  <app-buyer-service-invoices-list *ngIf="isBuyer"></app-buyer-service-invoices-list>
</div>
